// xgpre
const HOST = {
  origin: '',
  pplp: '//pplpxgpre.cnsuning.com',
  pplpsit: '//pplpsit.cnsuning.com', // 用于判断sit环境

  pppassportsend: '//pplpsit.cnsuning.com/passport',
  pppassport: '//10.200.20.21:8090/passport',
  snpassport: '//passportprexg.cnsuning.com',

  paypassport: '//paypassport.suning.com',

  suning: '//www.suning.com',
  pptv: '//www.pptv.com',
  wechat: '//open.weixin.qq.com',

  siller: '//dtxgpre.cnsuning.com', // 风控拖动取值
  aq: '//aqpre.cnsuning.com', // 解除风控
  vcs: '//vcsprexg.cnsuning.com',
  reg: '//regprexg.cnsuning.com', // 一账通升级URL

  snreg: '//reg.suning.com', // 苏宁注册
  ppgateway: '//ppgatewaysit.cnsuning.com',

  ppsports: '//ppwebsit.cnsuning.com',
  isports: '//sacssit.cnsuning.com',

  mppsport: '//mspssit.suning.com',
  ppgw: '//ppgwsit.cnsuning.com',
  vippptv: '//api.vip.pptv.com',
  pgoods: '//pgoodsxgpre.cnsuning.com',
  pcoupon: '//pcouponxgpre.cnsuning.com',
  apipay: '//psvppaysit1.cnsuning.com',
  porder: '//porderxgpre.cnsuning.com',
  ppwfs: '//ppwfspre.cnsuning.com',
};

const ENV = 'pre';

export {
  HOST,
  ENV,
};
